import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { css } from 'styled-components';
export const withFlex = _ref => {
  let {
    alignItems,
    flex,
    flexDirection,
    justifyContent
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), alignItems ? "align-items: ".concat(alignItems, ";") : '', flex ? "flex: ".concat(flex, ";") : '', flexDirection ? "flex-direction: ".concat(flexDirection, ";") : '', justifyContent ? "justify-content: ".concat(justifyContent, ";") : '');
};